import { Reducer } from 'redux';

import { lastVersionTypes, lastVersionState } from './types';

const INITIAL_STATE: lastVersionState = {
  lastVersion: '0.0.0',
};

const reducer: Reducer<lastVersionState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES SET_LOCAL_STORAGE_VERSION
    case lastVersionTypes.SET_LOCAL_STORAGE_VERSION:
      return {
        ...state,
        lastVersion: action.payload.version,
      };

    default:
      return state;
  }
};

export default reducer;
